/* eslint-disable indent */
import React from 'react'
import { ActionButton, Link } from '../../../../../../../components'
import { ACTION_COMPLETE, DETAILS, FEEDBACK, REVIEW } from '../pages'
import makeStyles from '@mui/styles/makeStyles'
import { Grid } from '@mui/material'
import { useFormFactor } from '../../../../../../../hooks'
import { routes } from '../../../../../../../routes'
import { useRetention } from '../hooks/useRetention'
import useAccountInfo from '../../../hooks/useAccountInfo'

const useStyles = makeStyles(({ palette }) => {
  const width = 180

  return {
    button: {
      width
    },
    confirmButton: {
      color: palette.alert.shade[50],
      borderColor: palette.alert.shade[50],
      width
    }
  }
})

const InPageState = ({ allow, children }) => {
  const { state } = useRetention()
  const allowed = Array.isArray(allow) ? allow : [allow]
  return allowed.includes(state.activePage) ? children : null
}

const FooterButtons = ({ stepComplete, onCancelConfirm }) => {
  const classes = useStyles()
  const { dispatch, state } = useRetention()
  const { isMobile } = useFormFactor()
  const { isMonthlyPlan, canSuspend } = useAccountInfo()

  if (state.activePage === ACTION_COMPLETE && state.action === 'cancellation') {
    return null
  }

  const justifyContent = [FEEDBACK, DETAILS, REVIEW].includes(state.activePage)
    ? 'space-between'
    : [ACTION_COMPLETE].includes(state.activePage)
    ? 'center'
    : 'flex-start'
  return (
    <Grid
      container
      direction={isMobile ? 'column' : 'row'}
      justifyContent={justifyContent}
      alignItems='center'
      spacing={2}
    >
      <InPageState allow={[DETAILS, FEEDBACK, REVIEW]}>
        <Grid item>
          <ActionButton
            variant='ghost'
            size='m'
            label='Close'
            data-test='retension-action-close'
            className={classes.button}
            component={Link}
            to={routes.profile.path}
          />
        </Grid>
      </InPageState>
      <InPageState allow={ACTION_COMPLETE}>
        <Grid item>
          <ActionButton
            variant='primary'
            size='m'
            label='Done'
            data-test='retension-action-done'
            className={classes.button}
            component={Link}
            to={routes.profile.path}
          />
        </Grid>
      </InPageState>
      <InPageState allow={[FEEDBACK, DETAILS, REVIEW]}>
        <Grid
          container
          spacing={1}
          alignItems='center'
          style={{ width: 'auto' }}
        >
          <InPageState allow={FEEDBACK}>
            <Grid item>
              <ActionButton
                variant='primary'
                className={classes.button}
                label='Continue'
                size='m'
                disabled={!stepComplete}
                onClick={() => dispatch({ type: 'continueButton' })}
                data-test='retension-action-continue'
              />
            </Grid>
          </InPageState>
          <InPageState allow={[DETAILS, REVIEW]}>
            <Grid item>
              <ActionButton
                variant='ghost'
                className={classes.button}
                size='m'
                label='Previous'
                onClick={() => dispatch({ type: 'previousButton' })}
                data-test='retension-action-previous'
              />
            </Grid>
          </InPageState>
          <InPageState allow={DETAILS}>
            <Grid item>
              <ActionButton
                variant='primary'
                size='m'
                label={isMonthlyPlan() && canSuspend() ? 'No, Thanks' : 'Continue'}
                className={classes.button}
                onClick={() => dispatch({ type: 'noThanksButton' })}
                data-test='retension-action-no'
              />
            </Grid>
          </InPageState>
          <InPageState allow={REVIEW}>
            <Grid item>
              <ActionButton
                variant='ghost'
                label='Confirm cancellation'
                className={classes.confirmButton}
                size='m'
                data-test='retension-action-cancel-confirm'
                onClick={onCancelConfirm}
              />
            </Grid>
          </InPageState>
        </Grid>
      </InPageState>
    </Grid>
  )
}

export default FooterButtons
